<div class="d-flex flex-row flex-nowrap">
	<span
		*ngFor="let i of _total; let index = index"
		[ngClass]="index === current ? 'text-primary' : 'text-light'"
		class="h1"
		>&#8226;</span
	>
</div>
